import { createContext } from 'react'
export type ElementLocation = 'header' | 'body' | 'footer' | 'hero'

export const ElementLocationContext = createContext<ElementLocation | undefined>(undefined)
